<form novalidate class="anpp">
  <div class="modal-header">
    <h5 class="modal-title" translate>Document préparatoire pour OC</h5>
  </div>

  <div class="modal-body">
    <div [formGroup]="formGroup" class="mb-3">
      <h6 class="modal-title"> Pour quel Organisme Certificateur souhaitez vous uploader le document ?</h6>
      <select formControlName="orgaCollecteur" (change)="changeValueOrgaCollecteur()">
        <option [ngValue]="null"></option>
        <option *ngFor="let orgaCollecteur of orgaCollecteursList" [ngValue]="orgaCollecteur">{{orgaCollecteur.raisonSociale}}</option>
      </select>
    <hr>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" (click)="cancel()" class="btn btn-light" translate>label.annuler</button>
    <button type="submit" (click)="buildDocumentAudit()" class="btn btn-primary" translate>label.valider</button>
  </div>
</form>
